<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/amplifier/gf.jpg" alt="功放系列">
            </div>
            <div class="detail-banner-r">

                <div class="detail-banner-t2">Amplifier Series</div>
                <div class="detail-banner-desc">
                    Self-developed vehicle-mounted power amplifier;<br />
                    Advanced DSP audio processing technology, restoring  delicate original sound with high
                    fidelity;<br />
                    Hierarchical platform-based design, ranging from the cost-optimized Booster platform to the
                    high-performance power amplifier platform, adapting to diverse acoustic scenario requirements;<br />
                    It features high power, modular design, rich interfaces, waterproof power amplifier, high
                    efficiency, high computing power, low distortion and environmental friendliness.
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">AB8 8-Channel Booster</div>
                    <div class="detail-desc">
                        <div>
                            Platformized hardware and structural design
                        </div>
                        <div>
                            Power amplifier structure with integrated mounting lugs
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/amplifier/AB8.jpg" alt="AB8 8-Channel Booster">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Product Specifications
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">134×119×33</div>
                                    <div class="k">Dimensions (mm)</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">600W</div>
                                    <div class="k">Rated Power</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">＜0.1% @1W/1kHz</div>
                                    <div class="k">THD (Total Harmonic Distortion)</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">＞85dB @1W/1kHz</div>
                                    <div class="k">Signal-to-Noise Ratio</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">A2B Wake-up</div>
                                    <div class="k"></div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">8 output channels, driving up to 13 loudspeakers</div>
                                    <div class="k"></div>
                                </div>

                                <div class="spec-item spec-item-last">
                                    <div class="v">Compatible with full boost mode for 4 or 8 channels</div>
                                    <div class="k"></div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Supports cascading of multiple A2B Boosters</div>
                                    <div class="k"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">AD12 12-Channel Amplifier</div>
                    <div class="detail-desc">
                        <div>
                            Platformized hardware, structural and software design
                        </div>
                        <div>
                            AUTOSAR software architecture
                        </div>
                        <div>
                            HSCAN communication support
                        </div>
                        <div>
                            OTA software upgrade supported
                        </div>
                    </div>
                </div>
                <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Product Specifications
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">198×150×40</div>
                                    <div class="k">Dimensions (mm)</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">620W</div>
                                    <div class="k">Rated Power</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">＜0.1% @1W/1kHz</div>
                                    <div class="k">THD (Total Harmonic Distortion)</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">＞85dB @1W/1kHz</div>
                                    <div class="k">Signal-to-Noise Ratio</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">12 output channels, driving up to 17 loudspeakers</div>
                                    <div class="k"></div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Stereo, 2D surround, multi listening sweet spots, iESE simulated
                                        engine sound, ENAC engine noise cancellation, etc.</div>
                                    <div class="k">High computing power, supports multiple personalized audio functions
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/amplifier/AD12.jpg" alt="AD12 12-Channel Amplifier">
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">AD20 20-Channel Amplifier</div>
                    <div class="detail-desc">
                        <div>
                            Platformized hardware, structural and software design
                        </div>
                        <div>
                            Built-in power management
                        </div>
                        <div>
                            AUTOSAR software architecture
                        </div>
                        <div>
                            HSCAN communication support
                        </div>
                        <div>
                            OTA software upgrade supported
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/amplifier/AD20.jpg" alt="AD20 20-Channel Amplifier">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Product Specifications
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">236×148×42</div>
                                    <div class="k">Dimensions (mm)</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1220W</div>
                                    <div class="k">Rated Power</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">＜0.03% @1W/1kHz</div>
                                    <div class="k">THD (Total Harmonic Distortion)</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">＞90dB @1W/1kHz</div>
                                    <div class="k">Signal-to-Noise Ratio</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">20 output channels, driving up to 27 loudspeakers</div>
                                    <div class="k"></div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Supports cascading A2B Boosters to expand output channels</div>
                                    <div class="k"></div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Stereo, 2D surround, 3D surround, 4D seat vibration, 7.1.4 immersive
                                        surround sound, iESE simulated engine sound, ENAC engine noise cancellation,
                                        RNAC road noise control, headrest surround sound, etc.</div>
                                    <div class="k">High computing power, supports premium audio features</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">AD24 24-Channel Amplifier</div>
                    <div class="detail-desc">
                        <div>
                            Platformized hardware, structural and software design
                        </div>
                        <div>
                            Built-in power management
                        </div>
                        <div>
                            AUTOSAR software architecture
                        </div>
                        <div>
                            HSCAN/CAN FD communication & Partial Networking support
                        </div>
                        <div>
                            OTA software upgrade supported
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Product Specifications
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">306×166×48</div>
                                    <div class="k">Dimensions (mm)</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">2400W, full Class D amplifier architecture</div>
                                    <div class="k">Rated Power</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">＜0.01% @1W/1kHz</div>
                                    <div class="k">THD (Total Harmonic Distortion)</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">＞90dB @1W/1kHz</div>
                                    <div class="k">Signal-to-Noise Ratio</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">24 output channels, driving up to 35 loudspeakers</div>
                                    <div class="k"></div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Supports cascading A2B Boosters to expand output channels</div>
                                    <div class="k"></div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Stereo, 2D surround, 3D surround, 4D seat vibration, 7.1.4 immersive
                                        surround sound, iESE simulated engine sound, advanced ENAC engine noise
                                        cancellation & RNAC road noise control, headrest surround sound, etc.</div>
                                    <div class="k">High computing power, supports full-scene immersive audio and
                                        functions</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/amplifier/AD24.jpg" alt="AD24 24-Channel Amplifier">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: 'Amplifier Series - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/electronics/amplifier.html'
};

import { createApp } from 'vue';
import App from './amplifier.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./amplifier.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
